import * as v from "valibot";
export const CLIENT_ENV_PREFIX = "PUBLIC_";
export const envSchema = v.object({
  /**
   * This is the backend API server. Empty means same-origin. In production it comes
   * from the container's PUBLIC_SERVER_URL at start (see window.__ENV__ below); the
   * container is expected to set it, even if only to an empty string.
   */
  PUBLIC_SERVER_URL: import.meta.env.PROD ? v.string() : v.optional(v.string(), ""),
  /**
   * Set this if you want to run or deploy your app at a base URL. This is
   * usually required for deploying a repository to Github/Gitlab pages.
   * Build-time only (Vite's `base`).
   */
  PUBLIC_BASE_PATH: v.pipe(v.optional(v.string(), "/"), v.startsWith("/"))
});
/**
 * Public config is read at page load from `window.__ENV__`, so one image serves any
 * environment. Vite's own env (`.env`, `pnpm dev`, tests) is the fallback, and
 * PUBLIC_BASE_PATH always comes from it: it is Vite's `base`, which is compiled into
 * the asset URLs and cannot change after the build.
 */
function runtimeSource() {
  const runtime = typeof window === "undefined" ? undefined : window.__ENV__;
  if (import.meta.env.PROD && !runtime) {
    throw new Error("Missing /env.js: window.__ENV__ is not set. The web container writes it from its PUBLIC_* env vars at start.");
  }
  return {
    ...import.meta.env,
    ...runtime,
    PUBLIC_BASE_PATH: import.meta.env.PUBLIC_BASE_PATH
  };
}
function parseEnv() {
  const result = v.safeParse(envSchema, runtimeSource());
  if (!result.success) {
    const problems = result.issues.map(issue => `${v.getDotPath(issue)}: ${issue.message}`);
    console.error(`Invalid runtime config (window.__ENV__):\n${problems.join("\n")}`);
    throw new Error("Invalid runtime config");
  }
  return result.output;
}
export const env = parseEnv();